import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-chatter-freeform',
  templateUrl: './chatter-freeform.component.html',
  styleUrls: ['./chatter-freeform.component.scss']
})
export class ChatterFreeformComponent {
  @ViewChild('input', { static: true, read: ElementRef })
  public input: ElementRef;

  @Output()
  public responseEntered: EventEmitter<any> = new EventEmitter<any>();

  public handleFreeformSelection(): void {
    this.responseEntered.emit(this.input.nativeElement.value);
  }
}
